/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponseOfPtw100BadRequestException,
  ErrorResponseOfPtw100MaintenanceModeException,
  ErrorResponseOfPtw100UnauthorizedException,
  LicenseStatusDto,
  LicenseTaskType,
  TenantLicenseDataDto,
} from '../models/index';
import {
    ErrorResponseOfPtw100BadRequestExceptionFromJSON,
    ErrorResponseOfPtw100BadRequestExceptionToJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON,
    ErrorResponseOfPtw100MaintenanceModeExceptionToJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionFromJSON,
    ErrorResponseOfPtw100UnauthorizedExceptionToJSON,
    LicenseStatusDtoFromJSON,
    LicenseStatusDtoToJSON,
    LicenseTaskTypeFromJSON,
    LicenseTaskTypeToJSON,
    TenantLicenseDataDtoFromJSON,
    TenantLicenseDataDtoToJSON,
} from '../models/index';

export interface AddDemoUsageRequest {
    taskType: LicenseTaskType;
    count?: number;
}

/**
 * 
 */
export class LicensesApi extends runtime.BaseAPI {

    /**
     * Add license usage records
     */
    async addDemoUsageRaw(requestParameters: AddDemoUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        if (requestParameters['taskType'] == null) {
            throw new runtime.RequiredError(
                'taskType',
                'Required parameter "taskType" was null or undefined when calling addDemoUsage().'
            );
        }


        const queryParameters: any = {};

        if (requestParameters['count'] != null) {
            queryParameters['count'] = requestParameters['count'];
        }

        if (requestParameters['taskType'] != null) {
            queryParameters['taskType'] = requestParameters['taskType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/licenses/add-demo-usage`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);


				// ++ Responses
         switch (response.status) {
          case 200: { 
							return new runtime.VoidApiResponse(response);
					}
          case 400: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100BadRequestExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100BadRequestException" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
							return new runtime.VoidApiResponse(response);
					}
				}
				// -- Responses
    }

    /**
     * Add license usage records
     */
     async addDemoUsage(requestParameters: AddDemoUsageRequest, errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<LicensesApi['addDemoUsageRaw']>>, void>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = void;

         const response = this.addDemoUsageRaw(requestParameters, initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the license data of the current tenant.
     */
    async getLicenseDataInfoRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/licenses/license-data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => TenantLicenseDataDtoFromJSON(jsonValue), "TenantLicenseDataDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => TenantLicenseDataDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the license data of the current tenant.
     */
     async getLicenseDataInfo(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<LicensesApi['getLicenseDataInfoRaw']>>, TenantLicenseDataDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = TenantLicenseDataDto;

         const response = this.getLicenseDataInfoRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Returns the current license status.
     */
    async getLicenseStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/licenses/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => LicenseStatusDtoFromJSON(jsonValue), "LicenseStatusDto" as const);
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						return new runtime.JSONApiResponse(response, (jsonValue) => LicenseStatusDtoFromJSON(jsonValue));
					}
				}
				// -- Responses
    }

    /**
     * Returns the current license status.
     */
     async getLicenseStatus(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<LicensesApi['getLicenseStatusRaw']>>, LicenseStatusDto>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = LicenseStatusDto;

         const response = this.getLicenseStatusRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

    /**
     * Pushes the pending license usages to the cso portal.
     */
    async pushUsagesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["ptw-api", "offline_access"]);
        }

        const response = await this.request({
            path: `/api/licenses/push-usages`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
         }, initOverrides);

         if (runtime.hasEmptyBody(response)) {
             return new runtime.VoidApiResponse(response);
         }

				// ++ Responses
         switch (response.status) {
          case 200: { 
						if (this.isJsonMime(response.headers.get('content-type'))) {
								return new runtime.JSONApiResponse<boolean>(response);
						} else {
								return new runtime.TextApiResponse(response) as any;
						}
					}
          case 401: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100UnauthorizedExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100UnauthorizedException" as const);
					}
          case 403: { 
												return new runtime.JSONApiResponse(response, (jsonValue) => ErrorResponseOfPtw100MaintenanceModeExceptionFromJSON(jsonValue), "ErrorResponseOfPtw100MaintenanceModeException" as const);
					}
					default: {
						if (this.isJsonMime(response.headers.get('content-type'))) {
								return new runtime.JSONApiResponse<boolean>(response);
						} else {
								return new runtime.TextApiResponse(response) as any;
						}
					}
				}
				// -- Responses
    }

    /**
     * Pushes the pending license usages to the cso portal.
     */
     async pushUsages(errorHandlers?: Array<(error: runtime.ApiErrorUnion<Awaited<ReturnType<LicensesApi['pushUsagesRaw']>>, boolean>) => runtime.ErrorHandlerResult>, initOverrides?: RequestInit | runtime.InitOverrideFunction) {
 				type SuccessResponse = boolean;

         const response = this.pushUsagesRaw(initOverrides);
         return this.configuration.handleFunction<SuccessResponse, typeof response>(response, errorHandlers);
     }

}
